module.exports = __webpack_public_path__ + "img/message-middle.cd1f5f12.svg";